import React from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { BarChart } from "@mui/x-charts/BarChart";
import Toggle from "react-toggle";
import "react-toggle/style.css";
const sizing = {
  margin: { right: 5 },
  width: 300, // Adjust width as needed
  height: 280, // Adjust height as needed
  legend: { hidden: true },
};

export default ({
  selectedOtherInterval,
  setSelectedOtherInterval,
  postList,
}) => {
  const currentYear = new Date().getFullYear();
  const futureYears = Array.from(
    { length: 5 },
    (_, index) => currentYear + index
  );

  const data = {
    daily: {
      aData:
        postList?.adminData?.res_data.length > 0
          ? postList?.adminData?.res_data
          : Array(31).fill(0),
      uData:
        postList?.userData?.res_data.length > 0
          ? postList?.userData?.res_data
          : Array(31).fill(0),
      xLabels: Array.from({ length: 31 }, (_, index) => `Day ${index + 1}`),
    },
    weekly: {
      aData:
        postList?.adminData?.res_data.length > 0
          ? postList?.adminData?.res_data
          : Array(7).fill(0),
      uData:
        postList?.userData?.res_data.length > 0
          ? postList?.userData?.res_data
          : Array(7).fill(0),
      xLabels: [
        "Week 1",
        "Week 2",
        "Week 3",
        "Week 4",
        "Week 5",
        "Week 6",
        "Week 7",
      ],
    },
    monthly: {
      aData:
        postList?.adminData?.res_data.length > 0
          ? postList?.adminData?.res_data
          : Array(12).fill(0),
      uData:
        postList?.userData?.res_data.length > 0
          ? postList?.userData?.res_data
          : Array(12).fill(0),
      xLabels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yearly: {
      aData:
        postList?.adminData?.res_data?.length > 0
          ? postList?.adminData?.res_data
          : Array(futureYears.length).fill(0),
      uData:
        postList?.userData?.res_data?.length > 0
          ? postList?.userData?.res_data
          : Array(futureYears.length).fill(0),
      xLabels: futureYears.length > 0 ? futureYears.map(String) : [],
    },
  };
  //for pie chart
  function convertData(originalData) {
    let convertedData = {
      data: [],
    };

    originalData[selectedOtherInterval]?.aData?.forEach((value, index) => {
      convertedData.data.push({
        value: value,
        label: `A ${originalData[selectedOtherInterval]?.xLabels[index]}`,
        color: "#2E96FF",
      });
    });

    originalData[selectedOtherInterval]?.uData?.forEach((value, index) => {
      convertedData.data.push({
        value: value,
        label: `U ${originalData[selectedOtherInterval]?.xLabels[index]}`,
        color: "#02B2AF",
      });
    });

    return convertedData;
  }
  const convertedData = convertData(data);

  return (
    <>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="">
                    <b>Post added by user/admin</b>
                  </h4>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <BarChart
                    series={[
                      {
                        data: data[selectedOtherInterval]?.uData,
                        label: "User",
                      },
                      {
                        data: data[selectedOtherInterval]?.aData,
                        label: "Admin",
                      },
                    ]}
                    xAxis={[
                      {
                        data: data[selectedOtherInterval].xLabels,
                        scaleType: "band",
                      },
                    ]}
                    // width={560}
                    height={300}
                  />
                </div>
                <PieChart
                  series={[
                    {
                      arcLabel: (item) => `${item.label} (${item.value})`,
                      arcLabelMinAngle: 45,
                      data: convertedData?.data,
                    },
                  ]}
                  sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                      fill: "white",
                      fontSize: 10,
                    },
                  }}
                  {...sizing}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
